class CartDrawer extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
		this.setHeaderCartIconAccessibility();
		this.setupElements();
	}

	setupElements() {
		this.dialog = this.querySelector('#CartDrawer-Content');
		this.backdrop = this.querySelector('#CartDrawer-Overlay');
		this.closeLinks = this.querySelectorAll('[data-close="cart-drawer"]');
		this.closeLinks.forEach((link) => link.addEventListener('click', this.close.bind(this)));
		this.backdrop.classList.add('transition-opacity');
		this.dialog.classList.add('transition-transform');
		this.backdrop.addEventListener('click', this.close.bind(this));
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble');
		cartLink.setAttribute('role', 'button');
		cartLink.setAttribute('aria-haspopup', 'dialog');
		cartLink.addEventListener('click', (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener('keydown', (event) => {
			if (event.code.toUpperCase() === 'SPACE') {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

		this.classList.add('hidden');
		this.dialog.classList.add('translate-x-full');
		this.backdrop.classList.add('opacity-0');
		this.classList.remove('hidden');
		this.offsetLeft; //reflow

		this.addEventListener(
			'transitionend',
			() => {
				const containerToTrapFocusOn = this.classList.contains('is-empty')
					? this.querySelector('.drawer__inner-empty')
					: document.getElementById('CartDrawer');
				const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		this.dialog.classList.remove('translate-x-full');
		this.backdrop.classList.remove('opacity-0');

		document.body.classList.add('overflow-hidden', 'has-overlay', 'has-cart-drawer');
	}

	isOpen() {
		return !this.classList.contains('hidden');
	}

	close() {
		this.classList.remove('hidden');
		this.addEventListener(
			'transitionend',
			() => {
				this.classList.add('hidden');
			},
			{ once: true }
		);

		this.dialog.classList.add('translate-x-full');
		this.backdrop.classList.add('opacity-0');

		removeTrapFocus(this.activeElement);
		document.body.classList.remove('overflow-hidden', 'has-overlay', 'has-cart-drawer');
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute(
				'aria-expanded',
				!event.currentTarget.closest('details').hasAttribute('open')
			);
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector('.drawer__inner').classList.contains('is-empty') &&
			this.querySelector('.drawer__inner').classList.remove('is-empty');
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
		});

		setTimeout(() => {
			this.setupElements();
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer',
				selector: '#CartDrawer',
			},
			{
				id: 'cart-icon-bubble',
			},
			{
				id: 'cart-json',
			},
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__inner',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-json',
				section: 'cart-json',
				selector: '.shopify-section',
			},
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);
